<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div class="row mx-0 mb-4 align-items-center">
		<span class="row-label mr-2">{{title}}</span>
		<slot></slot>
	</div>

</template>

<script>
    export default {
        name: "TitledRow",
		props:{
			title:String
		}

    }
</script>

<style scoped>
	.row-label{
		min-width: 130px;
	}
</style>
